var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "120",
        height: "40",
        viewBox: "0 0 120 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M8.57708 38.998C8.27219 38.998 7.97466 38.9941 7.67216 38.9874C7.04551 38.9793 6.42032 38.9251 5.80172 38.8254C5.22491 38.7267 4.66614 38.5433 4.14383 38.2811C3.62632 38.021 3.1543 37.68 2.74586 37.2712C2.33152 36.8671 1.98655 36.3985 1.72464 35.8839C1.45985 35.3659 1.27659 34.8107 1.18127 34.2376C1.07832 33.6218 1.02262 32.9991 1.01465 32.3749C1.00831 32.1654 1 31.4679 1 31.4679V8.51947C1 8.51947 1.00885 7.83262 1.0147 7.63083C1.02233 7.00764 1.07771 6.38594 1.18035 5.77109C1.27585 5.19642 1.45925 4.63961 1.72418 4.11994C1.98513 3.60566 2.32818 3.13669 2.74003 2.7312C3.15142 2.32186 3.62494 1.97911 4.14334 1.71547C4.66445 1.45408 5.22217 1.27193 5.79781 1.17511C6.41844 1.07434 7.0458 1.01986 7.67462 1.01213L8.57757 1H111.418L112.331 1.01262C112.954 1.01997 113.576 1.07396 114.191 1.17414C114.772 1.27217 115.336 1.45559 115.863 1.71838C116.902 2.2497 117.747 3.0903 118.28 4.12236C118.54 4.63845 118.721 5.19072 118.815 5.76042C118.919 6.38031 118.977 7.0069 118.989 7.6352C118.992 7.91653 118.992 8.21873 118.992 8.51947C119 8.892 119 9.24658 119 9.60407V30.3949C119 30.7558 119 31.1079 118.992 31.463C118.992 31.786 118.992 32.082 118.988 32.3866C118.977 33.0036 118.919 33.619 118.817 34.2278C118.724 34.8051 118.542 35.3646 118.277 35.8868C118.013 36.3959 117.67 36.8605 117.26 37.2634C116.852 37.6745 116.379 38.0175 115.86 38.2792C115.335 38.5434 114.772 38.7275 114.191 38.8254C113.572 38.9257 112.947 38.9798 112.32 38.9874C112.027 38.9941 111.72 38.998 111.422 38.998L110.338 39L8.57708 38.998Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M24.8384 20.2856C24.8492 19.4557 25.0715 18.6421 25.4847 17.9203C25.8978 17.1985 26.4885 16.5921 27.2015 16.1575C26.7485 15.516 26.1509 14.9882 25.4562 14.6158C24.7614 14.2434 23.9886 14.0367 23.1992 14.0122C21.5152 13.837 19.8827 15.0113 19.0246 15.0113C18.1499 15.0113 16.8287 14.0296 15.406 14.0587C14.4857 14.0881 13.5889 14.3535 12.8028 14.8288C12.0167 15.3041 11.3682 15.9731 10.9205 16.7708C8.98105 20.0999 10.4277 24.9925 12.2855 27.6835C13.215 29.0012 14.3013 30.4731 15.7228 30.421C17.1137 30.3638 17.6332 29.5416 19.3122 29.5416C20.9756 29.5416 21.463 30.421 22.9133 30.3878C24.4058 30.3637 25.3462 29.0642 26.2431 27.734C26.911 26.7951 27.4249 25.7574 27.7658 24.6594C26.8987 24.2957 26.1587 23.6871 25.6381 22.9093C25.1175 22.1315 24.8394 21.219 24.8384 20.2856Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M22.0991 12.2425C22.9129 11.2739 23.3138 10.0289 23.2167 8.77197C21.9734 8.90144 20.8249 9.49058 20.0001 10.422C19.5969 10.877 19.288 11.4064 19.0912 11.9798C18.8944 12.5533 18.8135 13.1596 18.8532 13.764C19.4751 13.7704 20.0903 13.6367 20.6526 13.3732C21.2148 13.1096 21.7094 12.723 22.0991 12.2425Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M42.421 23.2152H37.6743L36.5344 26.5522H34.5239L39.0199 14.2059H41.1087L45.6047 26.5522H43.5599L42.421 23.2152ZM38.1659 21.6753H41.9284L40.0736 16.2594H40.0217L38.1659 21.6753Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M55.3145 22.052C55.3145 24.8493 53.8044 26.6465 51.5256 26.6465C50.9483 26.6764 50.3742 26.5446 49.869 26.266C49.3638 25.9875 48.9479 25.5736 48.6689 25.0716H48.6258V29.5301H46.7622V17.5508H48.5661V19.0479H48.6004C48.8922 18.5484 49.3151 18.1366 49.8241 17.8564C50.3332 17.5761 50.9093 17.438 51.4913 17.4566C53.7956 17.4566 55.3145 19.2625 55.3145 22.052ZM53.399 22.052C53.399 20.2296 52.449 19.0314 50.9997 19.0314C49.5758 19.0314 48.618 20.2548 48.618 22.052C48.618 23.8657 49.5758 25.0804 50.9997 25.0804C52.4491 25.0804 53.399 23.891 53.399 22.052Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M65.3073 22.052C65.3073 24.8493 63.7972 26.6465 61.5184 26.6465C60.9411 26.6764 60.367 26.5446 59.8618 26.266C59.3566 25.9875 58.9407 25.5736 58.6618 25.0716H58.6186V29.5301H56.755V17.5508H58.5589V19.048H58.5932C58.8849 18.5484 59.3079 18.1366 59.8169 17.8564C60.326 17.5762 60.9021 17.438 61.4841 17.4566C63.7884 17.4566 65.3073 19.2625 65.3073 22.052ZM63.3918 22.052C63.3918 20.2296 62.4419 19.0315 60.9925 19.0315C59.5686 19.0315 58.6108 20.2548 58.6108 22.052C58.6108 23.8657 59.5686 25.0804 60.9925 25.0804C62.4419 25.0804 63.3918 23.891 63.3918 22.052Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M71.9117 23.1122C72.0498 24.3366 73.2495 25.1405 74.8888 25.1405C76.4597 25.1405 77.5898 24.3365 77.5898 23.2326C77.5898 22.2743 76.9082 21.7005 75.2943 21.3072L73.6804 20.9218C71.3937 20.3742 70.3321 19.3139 70.3321 17.5934C70.3321 15.4632 72.2046 14 74.8634 14C77.4948 14 79.2987 15.4632 79.3594 17.5934H77.4781C77.3655 16.3613 76.3382 15.6176 74.8369 15.6176C73.3356 15.6176 72.3083 16.3701 72.3083 17.4653C72.3083 18.3381 72.9645 18.8518 74.5696 19.245L75.9416 19.579C78.4966 20.178 79.5582 21.1956 79.5582 23.0015C79.5582 25.3113 77.7024 26.758 74.7507 26.758C71.9891 26.758 70.1245 25.3453 70.004 23.1122L71.9117 23.1122Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M83.5801 15.4206V17.5508H85.3067V19.014H83.5801V23.9764C83.5801 24.7473 83.9258 25.1066 84.6848 25.1066C84.8898 25.103 85.0944 25.0887 85.2978 25.0638V26.5183C84.9566 26.5815 84.6098 26.6101 84.2627 26.6037C82.4246 26.6037 81.7077 25.9192 81.7077 24.1735V19.014H80.3876V17.5508H81.7077V15.4206H83.5801Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M86.3066 22.052C86.3066 19.2198 87.989 17.4401 90.6126 17.4401C93.2449 17.4401 94.9196 19.2198 94.9196 22.052C94.9196 24.892 93.2538 26.6639 90.6126 26.6639C87.9723 26.6639 86.3066 24.892 86.3066 22.052ZM93.0207 22.052C93.0207 20.1092 92.1227 18.9625 90.6126 18.9625C89.1025 18.9625 88.2054 20.1179 88.2054 22.052C88.2054 24.0026 89.1025 25.1405 90.6126 25.1405C92.1227 25.1405 93.0207 24.0026 93.0207 22.052Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M96.456 17.5508H98.2335V19.0829H98.2766C98.3969 18.6044 98.6796 18.1815 99.0773 17.8853C99.475 17.5892 99.9634 17.4378 100.46 17.4566C100.675 17.4558 100.889 17.479 101.099 17.5255V19.2538C100.828 19.1716 100.545 19.1339 100.262 19.1421C99.9909 19.1312 99.721 19.1786 99.4704 19.2809C99.2199 19.3831 98.9946 19.538 98.8101 19.7347C98.6256 19.9315 98.4863 20.1655 98.4016 20.4207C98.317 20.6759 98.289 20.9462 98.3197 21.2131V26.5522H96.456L96.456 17.5508Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M109.691 23.9084C109.441 25.5425 107.836 26.6639 105.782 26.6639C103.141 26.6639 101.501 24.9094 101.501 22.0947C101.501 19.2713 103.15 17.4401 105.704 17.4401C108.216 17.4401 109.795 19.1509 109.795 21.8801V22.5132H103.383V22.6248C103.353 22.9561 103.395 23.2899 103.505 23.6039C103.616 23.9179 103.793 24.205 104.024 24.4462C104.255 24.6873 104.535 24.877 104.845 25.0025C105.156 25.1281 105.49 25.1867 105.825 25.1745C106.265 25.2154 106.707 25.1143 107.085 24.8862C107.463 24.6581 107.756 24.3151 107.922 23.9084L109.691 23.9084ZM103.392 21.2219H107.931C107.947 20.924 107.902 20.6259 107.797 20.3463C107.692 20.0667 107.53 19.8117 107.321 19.5972C107.111 19.3826 106.86 19.2133 106.582 19.0997C106.303 18.9862 106.004 18.9309 105.704 18.9373C105.4 18.9355 105.099 18.9933 104.818 19.1074C104.538 19.2214 104.282 19.3895 104.067 19.6019C103.852 19.8143 103.682 20.0668 103.566 20.3449C103.45 20.6229 103.391 20.921 103.392 21.2219Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }